import { defineMessages } from 'react-intl';

export default defineMessages({
    yourAutoInsuranceIncreased: {
        id: 'portal.views.rcn.yourAutoInsuranceIncreased',
        defaultMessage: 'Your auto insurance premium has increased'
    },
    yourHomeownersInsuranceIncreased: {
        id: 'portal.views.rcn.yourAutoInsuranceIncreasedPP',
        defaultMessage: 'Your homeowners insurance premium has increased'
    },
    policy: {
        id: 'portal.views.rcn.policy',
        defaultMessage: 'Policy #{policyNumber}'
    },
    reviewRenewal: {
        id: 'portal.views.rcn.reviewRenewal',
        defaultMessage: 'Please review some important information about your upcoming renewal for policy #{policyNumber}'
    },
    renewalMessagePA: {
        id: 'portal.views.rcn.renewalMessagePA',
        defaultMessage: 'Thank you for being a valued W Insurance member. The premium on your renewal offer has increased, and we\'d like to offer more information about why costs are significantly increasing throughout the auto insurance industry. Please review the Price Increase Notice and your Offer to Renew for more information on these changes. At W Insurance, we truly appreciate your decision to entrust us with your insurance needs and are committed to providing you with the protection and service you\'ve come to expect at a competitive price.'
    },
    renewalMessagePP: {
        id: 'portal.views.rcn.renewalMessagePP',
        defaultMessage: 'We truly appreciate you as a valued W Insurance member. As part of your homeowners insurance renewal, there is a price increase, and we want to make sure you\'re aware of this update. We believe in keeping you informed and transparent about any changes. Please take a moment to review your renewal offer and the details of the price increase.'
    },
    priceIncreaseNotice: {
        id: 'portal.views.rcn.priceIncreaseNotice',
        defaultMessage: 'Price Increase Notice (PDF)'
    },
    offerToRenew: {
        id: 'portal.views.rcn.offerToRenew',
        defaultMessage: 'Offer to Renew (PDF)'
    },
    dontShowAgain: {
        id: 'portal.views.rcn.dontShowAgain',
        defaultMessage: 'Don\'t show again'
    },
    close: {
        id: 'portal.views.rcn.close',
        defaultMessage: 'Close'
    }
});